import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const CreateConversionsPage = lazy(() => import("./CreateConversionsPage"));
const DetailConversionsPage = lazy(() => import("./DetailConversionsPage"));
const ViewConversionsPage = lazy(() => import("./ViewConversionsPage"));

const L = DefaultLayout;
const W = withSuspense;

export function getConversionsSuperadminRoutes() {
  return [
    { path: "/conversion/:id/details", layout: L, element: W(DetailConversionsPage) },
    { path: "/conversion/:id/edit", layout: L, element: W(CreateConversionsPage) },
    { path: "/conversion/view", layout: L, element: W(ViewConversionsPage) },
    { path: "/conversion/create", layout: L, element: W(CreateConversionsPage) },
  ];
}
